<template>
    <div>
        <StatusDialog
            v-if="isHomePage"
            :can-open="canOpenForStep(0)"
            @waiting="onWaiting"
            @processing="onProcessing"
        />
        <!-- <RepeatDialog
            :can-open="canOpenForStep(1)"
            @waiting="onWaiting"
            @processing="onProcessing"
        /> -->
        <Onboarding
            :can-open="canOpenForStep(1)"
            @waiting="onWaiting"
            @processing="onProcessing"
        />
        <SurveyFromListTrigger
            :can-open="canOpenForStep(2)"
            @waiting="onWaiting"
            @processing="onProcessing"
        />
        <!-- <SurveyFlow /> -->
        <PopupBanner
            :can-open="canOpenForStep(3)"
            @waiting="onWaiting"
            @processing="onProcessing"
        />
        <ReviewAppDialog
            :can-open="canOpenForStep(4)"
            @waiting="onWaiting"
            @processing="onProcessing"
        />
    </div>
</template>

<script>
    import store from '@/store';
    import { mapState } from 'vuex';
    // import ReviewDialog from '@/components/dialogs/ReviewDialog';
    import ReviewAppDialog from '@/components/dialogs/ReviewAppDialog';
    import StatusDialog from '@/components/dialogs/StatusDialog';
    import RepeatDialog from '@/components/dialogs/RepeatDialog';
    import PopupBanner from '@/components/dialogs/PopupBanner';
    import Onboarding from '@/components/dialogs/Onboarding';
    import SurveyFromListTrigger from '@/components/dialogs/SurveyFromListTrigger';
    import SurveyFlow from '@/components/common/SurveyFlow';
    import indexedDB from '@/plugins/indexedDB';

    export default {
        name: 'StatusObserver',

        components: {
            // ReviewDialog,
            StatusDialog,
            RepeatDialog,
            PopupBanner,
            Onboarding,
            SurveyFromListTrigger,
            SurveyFlow,
            ReviewAppDialog
        },

        props: {
            routerName: {
                type: String,
                default: ''
            }
        },
        
        data: () => ({
            canOpen: false,
            currentStep: 0,
            inProcess: false,
            routeName: null,
            isHomePage: false,
            queueFinished: false,
        }),

        computed: {
            ...mapState('orders', ['ordersStatuses']),
            totalSteps: () => 6,
        },

        // watch: {
        //     async inProcess() {
        //         await this.checkOrdersInWork();
        //     },
        // },

        // у него есть история показа страницы, с главной перехожу в магазины - магазин и когда с конкретного
        //  магазина нажимаю назад он допом подгружает главную чтобы быстро вернуться назад (т/е/ держит главную страницу загруженной)
        // можно ли как-то отключить?

        async mounted() {
            await this.handleRouteChange();
            this.checkOrdersInterval = setInterval(() => {
                this.handleRouteChange();
            }, 200);
            this.$root.$on('surveyFlowClosed', this.onSurveyFlowClosed);
            this.$root.$on('statusDialogShown', this.onDialogShown);
            this.checkIfSheetOpen();
        },
        beforeDestroy() {
            this.$root.$off('surveyFlowClosed', this.onSurveyFlowClosed);
            this.$root.$off('statusDialogShown', this.onDialogShown);
            if (this.checkOrdersInterval) clearInterval(this.checkOrdersInterval);
            // setTimeout(async () => {
            //     await this.clearOldStorage();
            //     this.$root.$on('newOrderInWork', this.checkOrdersInWork);
            //     await this.checkOrdersInWork();   
            // }, 250)
        },
        methods: {
            resetChain() {
                this.queueFinished = false;
                this.currentStep = 0;
                this.canOpen = false;
                this.checkIfSheetOpen();
            },

            handleRouteChange() {
                const newUrl = this?.$f7?.views?.main?.router?.url;
                const baseUrl = newUrl ? newUrl.split('?')[0] : newUrl;
                this.isHomePage = (baseUrl === '/' || baseUrl === '/home');
                if (this.routeName && this.routeName !== '/' && this.routeName !== baseUrl) {
                    this.$root.$emit('onboardingClose');
                }

                if (this.routeName !== baseUrl) {
                    this.resetChain();
                    setTimeout(() => {
                        const newUrl = this?.$f7?.views?.main?.router?.url;
                        const baseUrl = newUrl ? newUrl.split('?')[0] : newUrl;
                        if (baseUrl !== '/' && baseUrl !== '/home') {
                            this.$root.$emit('onboardingShow', { routeName: baseUrl });
                            this.routeName = baseUrl;
                        } else {
                            if (this.ordersStatuses?.length === 0) {
                                this.$root.$emit('onboardingShow', {});
                            }
                            this.routeName = baseUrl;
                        }
                    }, 300);
                }
            },
            async checkRouteName() {
                const currentUrl = this?.$f7?.views?.main?.router?.url;
                const routeName = currentUrl ? currentUrl.split('?')[0] : currentUrl;

                if(this.routeName && this.routeName !== '/' && this.routeName !== routeName) {
                    this.$root.$emit('onboardingClose');
                }

                if(this.routeName !== routeName) {
                    if(routeName !== '/' && routeName !== '/home') {
                        this.$root.$emit('onboardingShow', { routeName });
                        this.routeName = routeName;
                    } else {
                        if (this.ordersStatuses?.length === 0) {
                            this.$root.$emit('onboardingShow', {});
                            this.routeName = routeName;
                        }
                    }
                }
                
                return;
            },

            onSurveyFlowClosed() {
                this.waitProcessing(false);
                if (!this.queueFinished) this.checkIfSheetOpen();
            },

            onDialogShown() {
                this.queueFinished = true;
                this.currentStep = this.totalSteps;
            },

            canOpenForStep(step) {
                if (step === 1 && !this.isHomePage) return false;
                return this.canOpen && this.currentStep === step;
            },

            onWaiting() {
                this.advanceStep();
            },

            onProcessing(val) {
                if (val) {
                    this.queueFinished = true;
                    this.currentStep = this.totalSteps;
                } else if (!this.queueFinished) {
                    this.checkIfSheetOpen();
                }
                this.waitProcessing(val);
            },

            advanceStep() {
                this.currentStep++;
                while (this.currentStep === 1 && !this.isHomePage && this.currentStep < this.totalSteps) {
                    this.currentStep++;
                }
                if (this.currentStep >= this.totalSteps) {
                    this.queueFinished = true;
                    this.canOpen = false;
                }
            },

            async checkIfSheetOpen() {
                if (this.queueFinished) return;
                await this.timeout(2000);
                if (this.queueFinished) return;
                const sheet = this?.$f7?.sheet?.get();
                if (sheet?.opened) {
                    this.canOpen = false;
                    this.checkIfSheetOpen();
                    return;
                }
                this.canOpen = true;
                this.currentStep = 0;
            },

            // async checkOrdersInWork() {
            //     if (this.inProcess) {
            //         return;
            //     }
            //     await this.timeout(20000);

            //     let ordersInWork = await indexedDB.get('mircity-ordersInWork') || [];
            //     if (!ordersInWork?.length) {
            //         return;
            //     }

            //     try {
            //         const ordersFromServer = await store.dispatch('orders/getByIds', { orderIds: ordersInWork.map(order => order?.id) });
                    
            //         if(ordersFromServer && ordersFromServer.length > 0) {
            //             ordersInWork = ordersInWork.filter(order => {
            //                 for(const item of ordersFromServer) {
            //                     if(item.id === order.id) {
            //                         return true;
            //                     }
            //                 }
            //                 return false;
            //             });
            //             await indexedDB.set('mircity-ordersInWork', ordersInWork);
            //         } else {
            //             await indexedDB.remove('mircity-ordersInWork');
            //         }
            //     } catch (e) {}
                
            //     await this.checkOrdersInWork();
            // },

            waitProcessing(val = false) {
                this.inProcess = !!val;
            },

            // ! Should be deleted after some weeks...
            async clearOldStorage() {
                const ordersInWork = await indexedDB.get('mircity-ordersInWork') || [];
                if (!ordersInWork?.length) {
                    return;
                }

                const clearedOrders = ordersInWork?.filter(order => order != null && order.constructor === Object);
                await indexedDB.set('mircity-ordersInWork', clearedOrders);
            },

            timeout(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },
        }
    };
</script>
